import { Heart } from "lucide-react";
import { motion } from "framer-motion";
import { useFavorites } from "@/context/FavoritesContext";

export const FavButton = ({ slug, className = "" }) => {
  const { isFav, toggle } = useFavorites();
  const active = isFav(slug);
  return (
    <motion.button
      whileTap={{ scale: 0.8 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle(slug);
      }}
      data-testid={`fav-toggle-${slug}`}
      aria-label="Save to favourites"
      className={`flex h-9 w-9 items-center justify-center rounded-full backdrop-blur transition-colors ${
        active ? "bg-terracotta text-white" : "bg-white/85 text-petrol hover:text-terracotta"
      } ${className}`}
    >
      <Heart size={17} className={active ? "fill-current" : ""} />
    </motion.button>
  );
};
